import * as React from 'react';
import { path, pathOr } from 'ramda';
import { IBaseQuestionProps } from '../FormContainer/types/internal';
import { formContextObj } from '../FormContainer/context';
import { QuestionLayoutContainer } from '../QuestionLayoutContainer';
import { useDeviceType } from '@cian/ui-kit/responsive';
import { useFormTracking } from '../../utils/useFormTracking';
import { Textarea } from '../../components/Textarea';

export const LastQuestionContainer: React.FC<IBaseQuestionProps> = props => {
  const { answerField, placeholder, required, title } = props.question;
  const {
    quizSubmitError,
    quizSubmitting,
    handleCompleteQuiz,
    setAnswer,
    answersState,
    setNextStep,
    questionsMap,
    stepsMap,
    stepsHistory,
  } = React.useContext(formContextObj);

  const { trackSubmit, trackChange, trackFormSendEvent } = useFormTracking();

  const deviceType = useDeviceType();

  const handleChange = React.useCallback<React.ChangeEventHandler<HTMLTextAreaElement>>(
    e => {
      trackChange();

      setAnswer({ answerField, value: e.target.value });
    },
    [setAnswer, answerField, trackChange],
  );

  const handleSubmit = async () => {
    try {
      await handleCompleteQuiz({
        answersState,
        questionsMap,
        stepsMap,
        stepsHistory,
      });

      setNextStep(answersState);

      trackSubmit({
        isRequired: required,
        field: answerField,
        value: null,
      });

      trackFormSendEvent();
    } catch {
      trackSubmit({
        isRequired: required,
        field: answerField,
        value: 'submit error',
      });
    }
  };

  const isNextBtnDisabled = required && !Boolean(path([answerField, 'value'], answersState));

  return (
    <QuestionLayoutContainer
      title={title}
      onSubmit={handleSubmit}
      disableSubmit={isNextBtnDisabled}
      buttonText="Отправить заявку"
      showButtonPreloader={quizSubmitting}
      error={quizSubmitError || undefined}
      buttonFullWidth={deviceType !== 'desktop'}
    >
      <Textarea
        placeholder={placeholder || ''}
        onChange={handleChange}
        value={pathOr('', [answerField, 'value'], answersState)}
        rows={4}
      />
    </QuestionLayoutContainer>
  );
};

LastQuestionContainer.displayName = 'LastQuestionContainer';
